module.exports = __webpack_public_path__ + "img/armenia.4034a412.svg";